import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { FunctionalityClient } from '@frontend/functionality/api';
import { Functionality, FunctionalityQueryParams } from '@frontend/functionality/types';
import { getFuncionalityFullName } from '@frontend/functionality/utils';
import React, { useState } from 'react';

const ID = 'functionality-select';
export const FunctionalitySelectV2 = (props: ObjectSelectProps<Functionality, FunctionalityQueryParams>) => {
    const [v, cV] = useState<Functionality | null>(null);

    console.log(props.queryParams)
    return (
        <ObjectSelectInput<Functionality, FunctionalityQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Functionality'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => FunctionalityClient.fetchFunctionalities({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={getFuncionalityFullName}
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
